// src/api/metadata.ts
import axios from './axiosConfig';

const base = '/api/metadata';

export interface RecordMetadata {
    revision_group_id: string;
    severity: string | null;
    tags: string[];
}

// List of valid severities (used for dropdowns or validation)
export const SEVERITY_LEVELS = [
    'Unimportant',
    'Low',
    'Medium',
    'High',
    'Critical',
];

// GET metadata for a given revision group
export const fetchMetadata = async (
    revisionGroupId: string
): Promise<RecordMetadata> => {
    const response = await axios.get(`${base}/${revisionGroupId}`);
    return response.data;
};

// PATCH metadata (partial update)
export const updateMetadata = async (
    revisionGroupId: string,
    update: {
        severity?: string | null;
        tags?: string[];
    }
): Promise<RecordMetadata> => {
    const response = await axios.patch(`${base}/${revisionGroupId}`, update);
    return response.data;
};

// GET all unique tags across all records
export const fetchAllTags = async (): Promise<string[]> => {
    const response = await axios.get(`${base}/all-tags`);
    return response.data;
};

// GET metadata for multiple records
export const fetchMetadataBulk = async (
    revisionGroupIds: string[]
): Promise<RecordMetadata[]> => {
    const params = new URLSearchParams();
    revisionGroupIds.forEach((id) => params.append('revision_group_ids', id));
    const response = await axios.get(`${base}/bulk`, { params });
    return response.data;
};
